export const isLocalSentryLog = (): boolean => process.env.ENABLE_SENTRY_LOCALHOST_LOG === 'true'
